import './ApiSettings.scss';
import { Button, Container, Row, Col, Card, Modal } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { buyTokenModalAction } from '../../store/token/tokenActions';
import AddNewApiModal from '../../components/AddNewApi/AddNewApiModal';
import AddNewApiOkxModal from '../../components/AddNewApiOkx/AddNewApiOkxModal';
import binanceMiniIcon from '../../assets/img/logo/binance.png';
import okxMiniIcon from '../../assets/img/logo/okxMiniLogo.png';
import { exchangeInfo } from '../../helpers/exchangeInfo';
import {
  accountDetailsRequestAction,
} from '../../store/account/userActions';
import {
  apiKeyDeleteRequest,
} from '../../store/apiKey/apiKeyActions';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import {
  Key,
  Plus,
  Trash2,
  CheckCircle,
  XCircle,
  AlertTriangle,
  Settings,
  Shield,
  Link,
  Clock,
  User,
  Activity,
  Zap,
  Bot,
  X
} from 'lucide-react';

function ApiSettings({ ...props }) {
  const {
    buyTokenModalRequest,
    accountDetailsRequest,
    user,
    apiKeyDeleteRequest,
    success,
    successDelete,
  } = props;

  const history = useHistory();

  const [stake, setStake] = useState(true);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showOkxModal, setShowOkxModal] = useState(false);
  const [selectedTierId, setSelectedTierId] = useState(null);
  const [selectedExchangeName, setSelectedExchangeName] = useState(null);

  const handleShowOkxModal = () => {
    setShowOkxModal(true);
  };
  const handleCloseOkxModal = () => {
    setShowOkxModal(false);
  };
  const handleSaveOkxApi = (apiDetails) => {
    setShowOkxModal(false);
  };
  const deleteApi = async () => {
    if (!selectedExchangeName) return;

    setIsLoading(true);
    try {
      const payload = { exchange: selectedExchangeName };
      await apiKeyDeleteRequest(payload);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
      setShowDeletePopup(false);
    }
  };

  const stakeSetup = () => {
    setStake(true);
  };

  const handleShow = () => {
    buyTokenModalRequest(true);
  };

  useEffect(() => {
    if (props.success || props.successDelete !== null) {
      accountDetailsRequest();
    }
  }, [props.successDelete, props.success]);

  useEffect(() => {
    if (user?.api_key_status !== undefined) {
      accountDetailsRequest();
    }
  }, [user?.api_key_status, accountDetailsRequest]);

  const handleRedirectProfile = () => {
    history.push('/profile#profile');
  };

  const getApiStatus = (isOkx, item) => {
    if (item?.id === 3) {
      return {
        status: 'comingsoon',
        icon: Clock,
        text: 'Coming Soon',
        color: 'secondary'
      };
    }

    const hasApi = isOkx ? user?.okx : user?.binance;
    if (hasApi) {
      return {
        status: 'connected',
        icon: CheckCircle,
        text: 'Connected',
        color: 'success'
      };
    }

    return {
      status: 'disconnected',
      icon: XCircle,
      text: 'Not Connected',
      color: 'danger'
    };
  };


  const getButtonConfig = (item, isOkx) => {
    if (item.id === 3) {
      return {
        text: 'Coming Soon',
        variant: 'secondary',
        disabled: true,
        icon: Clock
      };
    }

    if (user?.is_active !== 'True') {
      return {
        text: 'User Not Verified',
        variant: 'warning',
        disabled: false,
        icon: User,
        action: handleRedirectProfile
      };
    }

    const hasApi = isOkx ? user?.okx : user?.binance;
    if (!hasApi) {
      return {
        text: 'Add New API',
        variant: 'primary',
        disabled: false,
        icon: Plus,
        action: () => {
          stakeSetup();
          setSelectedTierId(item.id);
          handleShow();
        }
      };
    }

    return {
      text: 'Delete API',
      variant: 'danger',
      disabled: false,
      icon: Trash2,
      action: () => {
        setSelectedExchangeName(item.title.toLowerCase());
        setShowDeletePopup(true);
      }
    };
  };

  console.log('user')
  console.log(user)
  return (
    <div className="modern-api-settings">
      <Container>
        {/* Modern Header */}
        <div className="api-header-section">
          <div className="header-content">
            <div className="header-left">
              <div className="api-title">
                <Key size={32} className="title-icon" />
                <h1>API Settings</h1>
              </div>
              <p className="api-subtitle">
                Connect your exchange accounts to enable automated trading
              </p>
            </div>
            <div className="header-stats">
              <div className="stat-item">
                <Activity size={20} />
                <div className="stat-content">
                  <span className="stat-number">
                    {[user?.okx, user?.binance].filter(Boolean).length}
                  </span>
                  <span className="stat-label">Connected</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Exchange Cards Grid */}
        <div className="exchanges-grid">
          <Row className="g-4">
            {exchangeInfo.map((item, index) => {
              const isOkx = index === 1;
              const apiStatus = getApiStatus(isOkx, item);
              const buttonConfig = getButtonConfig(item, isOkx,);
              const StatusIcon = apiStatus.icon;
              const ButtonIcon = buttonConfig.icon;

              return (
                <Col key={index} sm={12} md={6} lg={4}>
                  <Card className="modern-exchange-card">
                    {/* Card Header */}
                    <div className="exchange-card-header">
                      <div className="exchange-logo">
                        <img
                          src={isOkx ? okxMiniIcon : binanceMiniIcon}
                          alt={`${item.title} logo`}
                          className="exchange-icon"
                        />
                      </div>

                      <div className="status-indicator">
                        <StatusIcon
                          size={20}
                          className={`status-icon ${apiStatus.color}`}
                        />
                        <span className={`status-text ${apiStatus.color}`}>
                          {apiStatus.text}
                        </span>
                      </div>
                    </div>

                    {/* Exchange Info */}
                    <div className="exchange-info">
                      <h3 className="exchange-name">{item.title}</h3>
                      <p className="exchange-description">
                        {item.standart}
                      </p>
                    </div>

                    {/* Features */}
                    <div className="exchange-features">
                      <div className="feature-item">
                        <Shield size={16} className="feature-icon" />
                        <span>Secure API Connection</span>
                      </div>
                      <div className="feature-item">
                        <Link size={16} className="feature-icon" />
                        <span>Real-time Trading</span>
                      </div>
                      <div className="feature-item">
                        <Settings size={16} className="feature-icon" />
                        <span>Easy Configuration</span>
                      </div>
                    </div>

                    {/* Action Button */}
                    <div className="exchange-action">
                      <Button
                        className={`modern-action-btn ${buttonConfig.variant}-btn`}
                        variant={buttonConfig.variant}
                        onClick={buttonConfig.action}
                        disabled={buttonConfig.disabled}
                      >
                        <ButtonIcon size={16} />
                        <span>{buttonConfig.text}</span>
                      </Button>
                    </div>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </div>

        {/* Modern Delete Confirmation Modal */}
        <Modal
          show={showDeletePopup}
          onHide={() => setShowDeletePopup(false)}
          centered
          className="modern-delete-api-modal"
          backdrop="static"
        >
          {/* Modern Header */}
          <div className="modern-delete-header">
            <div className="header-icon">
              <AlertTriangle size={32} className="warning-icon" />
            </div>
            <div className="header-content">
              <h3 className="modal-title">Delete API Key</h3>
              <p className="modal-subtitle">
                Are you sure you want to remove {selectedExchangeName} API?
              </p>
            </div>
            <button className="modern-close-btn" onClick={() => setShowDeletePopup(false)}>
              <X size={20} />
            </button>
          </div>

          {/* Modal Body */}
          <div className="modern-delete-body">
            {/* Warning Message */}
            <div className="warning-section">
              <div className="warning-text">
                <h5>This action cannot be undone</h5>
                <p>
                  Deleting your API key will immediately disconnect your trading account 
                  and stop all automated operations.
                </p>
              </div>
            </div>

            {/* Consequences List */}
            <div className="consequences-section">
              <h6 className="consequences-title">What will happen:</h6>
              
              <div className="consequence-item critical">
                <div className="consequence-icon">
                  <Zap size={18} />
                </div>
                <div className="consequence-content">
                  <span className="consequence-label">All open trades canceled</span>
                  <small>Active positions will be closed immediately</small>
                </div>
              </div>

              <div className="consequence-item critical">
                <div className="consequence-icon">
                  <Bot size={18} />
                </div>
                <div className="consequence-content">
                  <span className="consequence-label">Connected bots unregistered</span>
                  <small>All trading bots will be disconnected</small>
                </div>
              </div>

              <div className="consequence-item warning">
                <div className="consequence-icon">
                  <Shield size={18} />
                </div>
                <div className="consequence-content">
                  <span className="consequence-label">API permissions revoked</span>
                  <small>You'll need to add API key again to resume</small>
                </div>
              </div>
            </div>

            {/* Confirmation Input */}
            <div className="confirmation-section">
              <div className="confirmation-notice">
                <AlertTriangle size={16} />
                <span>This will immediately stop all trading activities</span>
              </div>
            </div>
          </div>

          {/* Modern Footer */}
          <div className="modern-delete-footer">
            <Button
              variant="secondary"
              onClick={() => setShowDeletePopup(false)}
              className="cancel-action-btn"
              disabled={isLoading}
            >
              <XCircle size={16} />
              Keep API Key
            </Button>
            
            <Button
              variant="danger"
              onClick={deleteApi}
              disabled={isLoading}
              className="delete-action-btn"
            >
              <Trash2 size={16} />
              {isLoading ? (
                <>
                  <span className="loading-spinner"></span>
                  Deleting...
                </>
              ) : (
                'Delete API Key'
              )}
            </Button>
          </div>
        </Modal>

        {selectedTierId === 1 && stake ? <AddNewApiModal /> : null}
        {selectedTierId === 2 ? <AddNewApiOkxModal /> : null}
      </Container>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.userReducer.user,
  success: state.apiKeyReducer.success,
  successDelete: state.apiKeyReducer.successDelete,
});

const mapDispatchToProps = (dispatch) => ({
  buyTokenModalRequest: (payload) => {
    dispatch(buyTokenModalAction(payload));
  },
  accountDetailsRequest: (payload) => {
    dispatch(accountDetailsRequestAction(payload));
  },
  apiKeyDeleteRequest: (creds) => {
    dispatch(apiKeyDeleteRequest(creds));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ApiSettings);